import React, { Fragment } from "react";
import FormControl from "@material-ui/core/FormControl";
import { InputLabel, MenuItem } from "@material-ui/core";
import Select from "@material-ui/core/Select";

const ERROR_TYPES = [
  "EPUB_VALIDATION_ERROR",
  "FILE_VALIDATION_ERROR",
  "FUNCTION_ERROR",
  "PARSE_ERROR",
  "PROCESSING_ERROR",
  "VALIDATION_ERROR",
];

const ErrorTypeSelect = props => {
  const { onChange, label = "Error Type", value } = props;
  console.log(value);
  return (
    <Fragment>
      <FormControl fullWidth>
        <InputLabel shrink htmlFor="content-error-type">
          {label}
        </InputLabel>
        <Select
          value={value || ""}
          displayEmpty
          onChange={event => onChange(event.target.value)}
          inputProps={{
            name: "error-type",
            id: "error-type-select",
          }}
        >
          <MenuItem value="">All Errors</MenuItem>
          {ERROR_TYPES.map(et => {
            return (
              <MenuItem value={et} key={et}>
                {et}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Fragment>
  );
};

export default ErrorTypeSelect;
